import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';

import ParticipantCreationForm from './ParticipantCreationForm.jsx';

class Participants extends React.Component {
    static propTypes = {
        sportId: PropTypes.string.isRequired,
        participants: ImmutablePropTypes.list.isRequired,

        saveParticipant: PropTypes.func.isRequired,
        updateParticipant: PropTypes.func.isRequired,
        searchParticipant: PropTypes.func.isRequired
    };

    constructor( props, context ) {
        super( props, context );

        this.state = {
            searchCriteria: '',
            activeChar: '',
            selected: {},
            isCreation: true
        };

        this.searchByChar = this.searchByChar.bind( this );
        this.searchByString = this.searchByString.bind( this );

        this.saveParticipant = this.saveParticipant.bind( this );
        this.createParticipant = this.createParticipant.bind( this );

        this.onParticipantSelect = this.onParticipantSelect.bind( this );
    }

    searchByChar( event, activeChar ) {
        event.preventDefault();

        this.setState( {
            activeChar: activeChar === this.state.activeChar ? '' : activeChar,
            searchCriteria: ''
        } );

        this.props.searchParticipant( { prefix: activeChar } );
    }

    searchByString( event ) {
        const searchCriteria = event.target.value;

        this.setState( {
            activeChar: '',
            searchCriteria
        } );

        if ( searchCriteria.trim().length > 2 ) {
            const searchParams = searchCriteria.trim().search( ' ' ) !== -1 ?
                { name: searchCriteria } :
                { 'name.ngram': searchCriteria };

            this.props.searchParticipant( searchParams );
        }
    }

    saveParticipant( participant ) {
        const { isCreation } = this.state;
        const { saveParticipant, updateParticipant, sportId } = this.props;
        const data = Object.assign( {}, participant, { sport: { id: sportId } },
            { platformObject: participant.platformObject.externalId },
            {
                isCreation: false
            }
        );

        const dataUpdate = {
            name: participant.name,
            id: participant.id,
            sport: sportId,
            platformObject: participant.platformObject.externalId,
            isCreation: isCreation,
        };

        this.setState( {
            selected: {},
            isCreation: true
        } );

        // Remove platformObject object when not feed is specified
        if ( !data.platformObject.hasOwnProperty( 'feedId' ) || data.platformObject.feedId.trim().length < 3 ) {
            delete data.platformObject;
        }

        // Remove platformObject object when not feed is specified
        if ( !dataUpdate.platformObject.hasOwnProperty( 'feedId' ) || dataUpdate.platformObject.feedId.trim().length < 3 ) {
            delete dataUpdate.platformObject;
        }

        if ( isCreation ) {
            saveParticipant( data );
        } else {
            updateParticipant( dataUpdate );
        }
    }

    createParticipant( event ) {
        event.preventDefault();

        this.setState( {
            isCreation: true,
            selected: {}
        } );
    }

    onParticipantSelect( event, participant ) {
        this.setState( {
            isCreation: false,
            selected: participant.toJS()
        } );
    }

    render() {
        const alphabet = 'abcdefghijklmnopqrstuvwxyz#'.toUpperCase().split( '' );
        const { searchCriteria, activeChar, isCreation, selected } = this.state;
        const { participants } = this.props;

        const sortedParticipants = participants.filter( participant => {
            const participantName = participant.get( 'name' ).toLowerCase();
            return activeChar ?
                participantName.charAt( 0 ).toUpperCase().match(activeChar === '#' ? /[^a-zA-z]/gi : activeChar ) :
                participantName.match( searchCriteria.toLowerCase() );
        } ).sort( ( prev, next ) => {
            return prev.get( 'name' ).localeCompare( next.get( 'name' ) );
        } );

        return (
            <div className='sport-participants'>
                <div className='row'>
                    <div className='col-8 alphabet-filtering'>
                        {
                            alphabet.map( char => (
                                <span className='char-filter' key={ char }>
                                    <a
                                        href='#'
                                        className={ classnames( { 'is-active': char === activeChar } ) }
                                        onClick={ event => this.searchByChar( event, char ) }>
                                        { char }
                                    </a>
                                    &bull;
                                </span>
                            ) )
                        }
                    </div>

                    <div className='col-4'>
                        <div className='row'>
                            <div className='col-8'>
                                <div className='element'>
                                    <input
                                        onChange={ this.searchByString }
                                        type='text'
                                        placeholder='Search'
                                        value={ searchCriteria }
                                    />
                                </div>
                            </div>
                            <div className='col-4'>
                                <button
                                    type='button'
                                    className='btn btn-add'
                                    onClick={ this.createParticipant }>
                                    Add participant
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-8'>
                        <ul className='sport-general'>
                            {
                                !sortedParticipants.size ? (
                                    <div className='no-participant-message'>
                                        No participant available for this criteria
                                    </div>
                                ) : undefined
                            }

                            {
                                sortedParticipants.map( participant => {
                                    return (
                                        <li
                                            className={ classnames( 'participant', {
                                                'is-active': selected.id === participant.get( 'id' )
                                            } ) }
                                            key={ participant.get( 'id' ) }
                                            onClick={ event => this.onParticipantSelect( event, participant ) }
                                        >
                                            { participant.get( 'name' ) }
                                        </li>
                                    );
                                } )
                            }
                        </ul>
                    </div>

                    <div className='col-4'>
                        <ParticipantCreationForm
                            data={ selected }
                            isCreation={ isCreation }
                            onSubmit={ this.saveParticipant }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Participants;
